import React, { Component} from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ADMIN, PROJECT_MANAGER, DISPATCHER, FOREMAN} from './../config/global_constants';
import Auth from './../helpers/Auth';

import BlankLayout 		from "../layout/BlankLayout";
import Layout 			from "../layout/Layout";
import AfterLoginLayout from "./../layout/AfterLoginLayout";

/** Before Login page */
import Login 			from "./../components/Login";
import SSOLogin 		from "./../components/SSOLogin";
import Page404			from "./../components/Page404";

/** After Login page */
import Dashboard	from "./../components/Dashboard";
import EditProfile	from "./../components/EditProfile";

import EmployeeList				from "./../components/Employee/EmployeeList";
import AddEmployee				from "./../components/Employee/AddEmployee";

import calendar 				from "./../components/calendar/cal/DragAndDrop";
import SubContractor			from "../components/SubContractor/List";

import CustomerList				from "./../components/Customer/List";
import CustomerJob				from "./../components/Customer/CustomerJob";

import EquipmentList			from "./../components/Equipments/List";
import AddEditEquipment			from "./../components/Equipments/AddEditEquipment";
import EquipmentCost			from "./../components/Equipments/EquipmentCost";

import MasterList				from "../components/Master/List";
import WorkOrderList			from "../components/work_order/WorkOrderList";

import DepartmentCost			from "../components/DepartmentCost";
import LocateTicketList			from "../components/LocateTickets/LocateTicketList";
import JobsMap					from "./../components/JobMap";

/** Reports Modules */
import ReportJobList			from "../components/Reports/JobList";
import ReportPTOList			from "../components/Reports/PTOList";
import JobLookup				from "../components/Reports/JobLookup";
import SubcontractorReport		from "../components/Reports/Subcontractor";
import TrafficControlReport	from "../components/Reports/TrafficControl";
import EquipmentUtilization		from "../components/Reports/EquipmentUtilization";
import ResourcesAvailability	from "../components/Reports/ResourcesAvailability";
import EquipmentsAvailability	from "../components/Reports/EquipmentsAvailability";
import SystemLogList			from "./../components/SystemLogs/List";
import ActivityLogs				from "./../components/SystemLogs/ActivityLogs";
import ReportSetting			from "./../components/ReportSetting/List";
import scheduleList				from "./../components/schedule/ScheduleList";
import contractProfile			from "./../components/ContractProfile";
import NotificationList			from "./../components/Notifications/List";
import SystemLogin				from "./../components/SystemLogin";
import OnCall from "./../components/OnCall/OnCallList"

class Routes extends Component {
  render() {
    return (
      // <Router>
        <Switch>
          <Route exact path={["/","/calendar/:month","/calendar",'/contract-profile','/system-login']}>
            <BlankLayout>
              <PrivateRoute exact path="/" component={calendar}/>
              <PrivateRoute path="/calendar/:month" component={calendar}/>
              <PrivateRoute path="/calendar" component={calendar}/>
              <CommonRoute path="/contract-profile" component={contractProfile}/>
              <PublicRoute path="/system-login" component={SystemLogin}/>
            </BlankLayout>
          </Route>
          <Route exact path={["/forgot-password","/reset-password/:validate_string","/admin-login"]}>
            <Layout>
              <PublicRoute path="/admin-login" component={Login}/>
            </Layout>
          </Route>
          <Route exact path={["/login"]}>
            <BlankLayout>
              <PublicRoute path="/login" component={SSOLogin}/>
            </BlankLayout>
          </Route>

          {/** AFter login routes  */}
          <Route exact path={[ "/dashboard", "/edit-profile", "/employees", "/employees/add", "/employees/update/:employee_id", "/sub-contractor" ,"/equipments", "/master/:dropdown_type", "/work-order","/department-cost","/locate-tickets", "/reports/job-list","/map","/auto-complete","/reports/timeoff-report","/reports/resources-availability","/customer","/customer/:customer_code","/reports/jobs-lookup","/reports/equipment-utilization", "/equipments-upload","/reports/subcontractor","/reports/traffic-control","/equipments/add","/equipments/update/:equipment_id","/job-map","/equipment-cost","/reports/available-equipments","/system-logs","/holidays","/report-settings","/activity-logs","/notifications","/on-call"]}>
            <AfterLoginLayout>
              {/* <PrivateRoute exact path="/" component={Dashboard}/> */}
              <PmAdminDispatcherRoute exact path="/dashboard" component={Dashboard}/>
              <PrivateRoute path="/edit-profile" component={EditProfile}/>

              <PmAdminDispatcherRoute exact path="/employees" component={EmployeeList}/>
              <PmAdminDispatcherRoute path="/employees/add" component={AddEmployee}/>
              <AdminDispatcherRoute path="/employees/update/:employee_id" component={AddEmployee}/>

              <PmAdminDispatcherRoute exact path="/customer" component={CustomerList}/>
              <PmAdminDispatcherRoute path="/customer/:customer_code" component={CustomerJob}/>

              <PmAdminDispatcherRoute path="/sub-contractor" component={SubContractor}/>
              <PrivateRoute path="/department-cost" component={DepartmentCost}/>
              <PrivateRoute path="/equipment-cost" component={EquipmentCost}/>

              <AdminDispatcherProjectRoute exact path="/equipments" component={EquipmentList}/>
              <AdminDispatcherRoute path="/equipments/add" component={AddEditEquipment}/>
              <AdminDispatcherRoute path="/equipments/update/:equipment_id" component={AddEditEquipment}/>

              <PrivateRoute path="/locate-tickets" component={LocateTicketList}/>
              <PmAdminDispatcherRoute path="/master/:dropdown_type" component={MasterList}/>
              <AdminRoute path="/work-order" component={WorkOrderList}/>
              <AdminDispatcherRoute path="/holidays" component={scheduleList}/>
              <AdminRoute path="/report-settings" component={ReportSetting}/>

              <PrivateRoute path="/reports/job-list" component={ReportJobList}/>
              <PrivateRoute path="/reports/timeoff-report" component={ReportPTOList}/>
              <PmAdminDispatcherRoute path="/reports/resources-availability" component={ResourcesAvailability}/>
              <PrivateRoute path="/reports/available-equipments" component={EquipmentsAvailability}/>
              <PmAdminDispatcherRoute path="/reports/jobs-lookup" component={JobLookup}/>
              <PrivateRoute path="/reports/equipment-utilization" component={EquipmentUtilization}/>
              <PrivateRoute path="/reports/subcontractor" component={SubcontractorReport}/>
              <PrivateRoute path="/reports/traffic-control" component={TrafficControlReport}/>

              <AdminDispatcherRoute path="/system-logs" component={SystemLogList}/>
              <AdminDispatcherRoute path="/activity-logs" component={ActivityLogs}/>

              <PrivateRoute path="/job-map" component={JobsMap}/>

              <PrivateRoute exact path="/on-call" component={OnCall}/>

              <PmAdminDispatcherRoute exact path="/notifications" component={NotificationList}/>
            </AfterLoginLayout>
          </Route>
          <BlankLayout>
            <CommonRoute path="*" component={Page404} />
          </BlankLayout>
        </Switch>
      // </Router>
    );
  }
}

const CommonRoute = ({ component : Component, ...rest }) => ( <Route{...rest} render={ props =>Auth.getAuth() ? (<Component {...props} /> ) : ( <Component {...props} />)} />);
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.getAuth() ? (
        <>
          {props && props.location && props.location.search && props.location.search.indexOf('callbackUrl')!== -1 && props.location.search.split('?callbackUrl=')?.[1].indexOf('login') !== -1 ?
            <Redirect to={props.location.search.replace('?callbackUrl=','')} />
          :
            <Component {...props} />
          }
        </>
      ) : (
        <>
          {props && props.location && props.location.search && props.location.search.indexOf('callbackUrl') !== -1 && props.location.search.split('?callbackUrl=')?.[1].indexOf('login') !== -1 ?
            <Redirect to={`/login${props.location.search}`}  />
          :
            <Redirect to='/login'  />
          }
        </>
      )
    }
  />
);

const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      Auth.getAuth() ? (
        <>
          {props && props.location && props.location.search && props.location.search.indexOf('callbackUrl') !== -1 ?
            <Redirect to={props.location.search.replace('?callbackUrl=','')} />
          :
            <Redirect to='/calendar'  />
          }
        </>
      ) : (props && props.location && props.location.search && props.location.search.indexOf('callbackUrl') !== -1 && props.location.search.split('?callbackUrl=')?.[1].indexOf('login') !== -1 ?
        <Redirect to='/login'  />
      :
        <Component {...props} />
      )
    }
  />
);

const PmAdminDispatcherRoute = ({ component : Component, ...rest }) => ( <Route{...rest} render={ props =>([ ADMIN, PROJECT_MANAGER, DISPATCHER, FOREMAN].indexOf(Auth.getPermission()) !== -1) ? (<Component {...props} /> ) : (<Redirect to='/calendar'  />)} />);
const AdminDispatcherRoute = ({ component : Component, ...rest }) => ( <Route{...rest} render={ props =>([ ADMIN, DISPATCHER].indexOf(Auth.getPermission()) !== -1) ? (<Component {...props} /> ) : (<Redirect to='/calendar'  />)} />);
const AdminDispatcherProjectRoute = ({ component : Component, ...rest }) => ( <Route{...rest} render={ props =>([ ADMIN, DISPATCHER, PROJECT_MANAGER].indexOf(Auth.getPermission()) !== -1) ? (<Component {...props} /> ) : (<Redirect to='/calendar'  />)} />);
const AdminRoute = ({ component : Component, ...rest }) => ( <Route{...rest} render={ props =>([ ADMIN ].indexOf(Auth.getPermission()) !== -1) ? (<Component {...props} /> ) : (<Redirect to='/calendar'  />)} />);
export default Routes;
